export const projectsData = [
  {
    id: 1,
    projectName: "ShopKart ",
    desc1: "Features - Authentication, Search, Filter, Review, Rating, Payment Gateway etc. ",
    desc2: "An Admin panel to manage orders, users, products, reviews",
    tags: ["MongoDB", "Express", "React", "NodeJS"],
    logos: ["fas fa-database", "fab fa-etsy", "fab fa-react", "fab fa-node"],
    code: "https://github.com/Sangamchoudhary/ShopKart",
    demo: "https://shopkart-always-in-style.herokuapp.com/",
    image: "https://i.ibb.co/jRL9Q6T/ezgif-com-gif-maker-2.gif",
  },
  {
    id: 2,
    projectName: "Asteroid Game",
    desc1: "3 Levels - Easy, Medium, Hard",
    desc2: "3 Weapons - Small, Big, Mega",
    tags: ["HTML", "CSS", "JAVASCRIPT",],
    logos: [
      "fab fa-html5",
      "fab fa-css3",
      "fab fa-js",
    ],
    code: "https://github.com/Sangamchoudhary/AsteroidBlaster",
    demo: "https://sangamchoudhary.github.io/AsteroidBlaster/",
    image: "https://i.ibb.co/sbP0yT5/ezgif-com-gif-maker-3.gif",
  },
  // {
  //   id: 3,
  //   projectName: "Epic Games",
  //   projectDesc:
  //     "Epic Games develops the Unreal Engine , a commercially available game engine which also powers their internally developed video games, such as Fortnite and the Unreal , Gears of War and Infinity Blade series.",
    // tags: ["HTML", "CSS", "JAVASCRIPT", "Tailwind", "Node.js", "Bootstrap"],
    // logos: [
    //   "fab fa-html5",
    //   "fab fa-css3",
    //   "fab fa-bootstrap",
    //   "fab fa-js",
    //   "fab fa-node",
    // ],
  //   code: "https://github.com/salakhas/epicGames",
  //   demo: "https://epic-games-full-stack.vercel.app/",
  //   image: "https://i.ibb.co/pvnTv6Y/ezgif-com-gif-maker.gif",
  // },
  // {
  //   id: 4,
  //   projectName: "BEWAKOOF",
  //   projectDesc:
  //     "It  is an  e-commerce website where users can purchase clothing for both  Men and Women.",
  //   tags: ["HTML", "CSS", "JAVASCRIPT"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/BewaKoof_Clone",
  //   demo: "https://nitish8800.github.io/BewaKoof_Clone/",
  //   image: "https://i.ibb.co/35KFWd8/ezgif-com-gif-maker.gif",
  // },
  // {
  //   id: 5,
  //   projectName: "Mini Github Clone",
  //   projectDesc:
  //     "GitHub is an increasingly popular programming resource used for code sharing. It's a social networking site for programmers that many companies and organizations use to facilitate project management and collaboration.",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/Mini_Github_Clone",
  //   demo: "https://nitish8800.github.io/Mini_Github_Clone/",
  //   image: "https://i.ibb.co/K74cqWc/ezgif-com-gif-maker.gif",
  // },
  // {
  //   id: 6,
  //   projectName: "YouTube Clone",
  //   projectDesc:
  //     "YouTube is a free video sharing website that makes it easy to watch online videos. This clone allows users to search any video and can play.",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/YouTube-_Clone-",
  //   demo: "https://nitish8800.github.io/YouTube-_Clone-/",
  //   image: "https://i.ibb.co/17k8Zw8/ezgif-com-gif-maker-1.gif",
  // },
  // {
  //   id: 7,
  //   projectName: "Mini Amazon E-Commerce",
  //   projectDesc:
  //     "In this Website user can shopping any products and there is also admin panel admin can upload the new product data",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/Mini_Amazon_e-commerce",
  //   demo: "https://nitish8800.github.io/Mini_Amazon_e-commerce/",
  //   image: "https://i.ibb.co/qFXJz1v/ezgif-com-gif-maker.gif",
  // },
  // {
  //   id: 8,
  //   projectName: "Weather App",
  //   projectDesc:
  //     "In this Weather App users can see weather even 7 days forecast also and there is also a map for all city. users can search any city and get the weather deatails",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/Weather_App",
  //   demo: "https://nitish8800.github.io/Weather_App/",
  //   image: "https://i.ibb.co/Phyy8Bc/ezgif-com-gif-maker.gif",
  // },
  // {
  //   id: 9,
  //   projectName: "Calculator",
  //   projectDesc:
  //     "In this Calculator users can calculate any data. there is all functionality like add, sub, divide, and multiply.",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/Calculator",
  //   demo: "https://github.com/Nitish8800/Calculator",
  //   image: "https://i.ibb.co/WcPfSnw/ezgif-com-gif-maker-1.gif",
  // },
  // {
  //   id: 10,
  //   projectName: "Solar_System",
  //   projectDesc:
  //     "I attended one day bootcamp workshop at masai. there I got create this solar system with animation",
  //   tags: ["Html", "css", "javascript"],
  //   logos: ["fab fa-html5", "fab fa-css3", "fab fa-js"],
  //   code: "https://github.com/Nitish8800/Solar_System",
  //   demo: "https://nitish8800.github.io/Solar_System/",
  //   image: "https://i.ibb.co/TgtjHz8/ezgif-com-gif-maker.gif",
  // },
];

//schema for entwreing data
/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
